<template>
  <centered-layout>
    <div class="text-center">
      <v-progress-circular color="primary" class="mb-4" indeterminate></v-progress-circular>
      <p v-if="title" class="subtitle-1 font-weight-regular mb-0 text--primary">{{ title }}</p>
    </div>
  </centered-layout>
</template>

<script>
import CenteredLayout from './CenteredLayout.vue';

export default {
  props: {
    title: {
      type: String,
    },
  },
  components: { CenteredLayout },
};
</script>
